export const updateNewClient = 'updateNewClient';
export const updateIsAddClientClicked = 'updateIsAddEmployeeClicked';
export const updateClients = "updateClients";
export const updateIsEditClientClicked = "updateIsEditClientClicked";
export const updateClientsDataTable = "updateClientsDataTable";
export const updateIsViewClientClicked = "updateIsViewClientClicked";